import { TechnologyData } from "../technology";
import { createValuesFor, setValue } from "../../__mock__/calculation-values";

export default {
  id: "xiga",
  name: "xiga",
  oneliner: "High pressure, smallest footprint",
  image: "/images/technologies/XIGA.jpg",
  techImage: [
    "/images/tech_images/XIGA/XIGA.png",
    "/images/tech_images/XIGA/Pentair XIGA comp_01.png",
    "/images/tech_images/XIGA/Pentair XIGA comp_02.png",
    "/images/tech_images/XIGA/Pentair XIGA comp_03.png",
    "/images/tech_images/XIGA/Pentair XIGA comp_04.png"
  ],
  active: true,
  comparableTechnologies: ["xline", "xiga", "aquaflex"],
  description:
    "The ultrafiltration solution with the highest membrane area-to-footprint ratio in the market.Specifically suited for large-scale (>10 MLD) municipal or industrial water polishing for drinkingwater production or reuse.",
  values: [
    ...createValuesFor("design.details", [
      // Detailed feed parameters
      setValue("account_name", ["Partner3"]),
      setValue("opportunity_number", ["OP-3456712"]),
      setValue("project_name", ["UF Water treatment"]),
      setValue("project_destination", ["Sweden"]),
      setValue("designer", ["Karthi Pitchaikani"]),
      setValue("approver", ["-"])
    ]),
    ...createValuesFor("input.feed.detailed", [
      // Detailed feed parameters
      setValue("temperature_range", [15, 35]),
      setValue("ph_range", [7.8, 8.2]),
      setValue("calcium", [410]),
      setValue("ammonia", [1]),
      setValue("phosphorus", [1])
    ]),
    ...createValuesFor("input.water.main", [
      // Main water parameters
      setValue("design_turbidity", [10]),
      setValue("temperature", [20]),
      setValue("turbidity", [10]),
      setValue("tss", [10]),
      setValue("toc", [3]),
      setValue("cod", [5]),
      setValue("color", [10]),
      setValue("alkanity", [130]),
      setValue("ph", [7.2]),
      setValue("tds", [40000]),
      setValue("hardness", [6900])
    ]),
    ...createValuesFor("input.plant.capacity", [
      // Plant Capacity
      setValue("water_source", ["Sea water"]),
      setValue("capacity_base", ["Permeate production"]),
      setValue("capacity", [1000]),
      setValue("temperature", [20])
    ]),
    ...createValuesFor("input.plant.membrane", [
      //
      setValue("membrane")
    ]),
    ...createValuesFor("plant.configuration", [
      setValue("total_units", [3]),
      setValue("membrane_element", ["XF64"]),
      setValue("total_membrane_elements", [216]),
      setValue("spare_membrane_housings", [0]),
      setValue("total_mebrane_area", [13824]),
      setValue("backwash_trains", [1]),
      setValue("xiga_membrane_elements", [4]),
      setValue("membrane_housings", [18])
    ]),
    ...createValuesFor("plant.configuration.image", [
      setValue("avg_feed_flow", [1052.0]),
      setValue("fecl3_dosing_pump", [5.6]),
      setValue("feed_pumps", [1107.3]),
      setValue("backwash_pumps", [1105.9]),
      setValue("net_permeate_flow", [1000]),
      setValue("total_concentrate_flow", [52.0]),
      setValue("avg_backwash_flow", [44.2]),
      setValue("avg_ceb_1_flow", [7.7])
    ]),
    ...createValuesFor("results", [
      // Calculated results
      setValue("gross_filtration_flux", [80.1]),
      setValue("filtration_time", [45]),
      setValue("net_filtration_flux", [72.3]),
      setValue("avg_ceb_1_counter", [24.5]),
      setValue("ceb_1_counter", [31]),
      setValue("recovery", [95.1])
    ]),
    ...createValuesFor("results.pump.naocl", [
      // Calculated results
      setValue("naocl_dosing_pump", [1105.9]),
      setValue("naocl_consumption", [27.6])
    ]),
    ...createValuesFor("results.pump.naoh", [
      // Calculated results
      setValue("naoh_dosing_pump", [249.8]),
      setValue("naoh_consumption", [6.2])
    ]),
    ...createValuesFor("results.pump.h2so4", [
      // Calculated results
      setValue("h2so4_dosing_pump", [387.6]),
      setValue("h2so4_consumption", [9.7])
    ]),
    // net made values for demo
    setValue("uf_feed_pump", [1107.3]),
    setValue("fecl3_coagulant_pump", [5.6]),
    setValue("membrane_elements", [4], undefined, "per housing")
  ],
  techImageMap: [
    {
      title: "Plant configuration",
      titleVariant: "big",
      location: [3, 5],
      width: 300,
      rotation: 0,
      align: "left",
      values: [
        "total_units",
        "membrane_housings",
        "spare_membrane_housings",
        "xiga_membrane_elements",
        "total_membrane_elements",
        "membrane_element",
        "total_mebrane_area",
        "backwash_trains"
      ]
    },
    {
      title: null,
      values: ["avg_feed_flow"],
      location: [8, 83],
      rotation: -14,
      width: 160,
      align: "left",
      info: null,
      titleVariant: "small"
    },
    {
      title: null,
      values: ["feed_pumps"],
      location: [20, 92],
      rotation: 0,
      width: 160,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["net_permeate_flow"],
      location: [93, 41],
      rotation: -10,
      info: null,
      width: 80,
      align: "left",
      titleVariant: "small"
    },
    {
      title: "NaOCL CEB",
      values: ["naocl_dosing_pump", "naocl_consumption"],
      location: [55, 33],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
      // line: "M 1 1 1 30 l50 30"
    },
    {
      title: "NaOH CEB",
      values: ["naoh_dosing_pump", "naoh_consumption"],
      location: [67, 30],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
    },
    {
      title: "H₂SO₄ CEB",
      values: ["h2so4_dosing_pump", "h2so4_consumption"],
      location: [79, 27],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["fecl3_dosing_pump"],
      location: [30, 90],
      rotation: 0,
      width: 160,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["backwash_pumps"],
      location: [66, 63],
      rotation: 0,
      width: 120,
      align: "left",
      titleVariant: "small"
    },
    {
      title: "Concentrate",
      values: ["total_concentrate_flow", "avg_backwash_flow", "avg_ceb_1_flow"],
      titleVariant: "small",
      location: [85, 73],
      width: 250,
      align: "right",
      info: null,
      rotation: 0
    }
  ]
} as TechnologyData;
